import { Routes } from '@angular/router';

import { SceneComponent } from './scene/scene.component';


export const AppRoutes: Routes = [{
        path: '',
        component: SceneComponent
}];
